import { useState, useEffect } from 'react'
import DashboardMultiSelect from '../../../GlobalComponents/_misc/DashboardMultiSelect'
import {
    SalesReportArea,
    SalesDivision,
    Salesperson,
} from '../../../features/salesperson/salespersonAPI'

interface SalespersonMultiSelectProps {
    data: Salesperson[]
    selectedSalesDivisions: SalesDivision[]
    selectedValues: Salesperson[]
    onSelectedValuesChanged(selectedValues: Salesperson[]): void
}

const SalespersonMultiSelect = (props: SalespersonMultiSelectProps) => {
    const [salespeople, setSalespeople] = useState<Salesperson[]>([])
    const [selectedSalesDivisions, setSelectedSalesDivisions] = useState<SalesReportArea[]>([])
    const [selectedValues, setSelectedValues] = useState<Salesperson[]>([])

    useEffect(() => {
        // Only keep salespeople that exist in selected Division list
        const newSelectedValues = selectedValues.filter((d) =>
            props.selectedSalesDivisions.some(
                (group) => group.Division === d.SalespersonCode.substring(0, 2)
            )
        )
        if (newSelectedValues.length !== selectedValues.length) onChange(newSelectedValues)

        const getUnique = (arr: any[], props: string[] = []) => [
            ...new Map(arr.map((entry) => [props.map((k) => entry[k]).join('|'), entry])).values(),
        ]

        // Get unique salespeople that exist in selected Sales Divisions list
        const spData = getUnique(
            [
                ...new Set(
                    props.data
                        .filter((sp) =>
                            props.selectedSalesDivisions.some(
                                (d) => d.Division === sp.SalespersonCode.substring(0, 2)
                            )
                        )
                        .map((sp) => ({
                            SalespersonCode: sp.SalespersonCode,
                            SalespersonName: sp.SalespersonName,
                            SalespersonCodeName: sp.SalespersonCodeName,
                        }))
                ),
            ],
            ['SalespersonCode', 'SalespersonName']
        )

        setSalespeople(spData)

        // // If division is newly-added, select all of its salespeople - should be new to data
        // const newDivisions = props.selectedSalesDivisions.filter(
        //     (sd) =>
        //         !selectedSalesDivisions.some(
        //             (ssd) =>
        //                 sd.Team === ssd.Team &&
        //                 sd.ReportGroup === ssd.ReportGroup &&
        //                 sd.ReportArea === ssd.ReportArea
        //         )
        // )
        // if (newDivisions.length > 0) {
        //     const newSPData = spData.filter((sp) =>
        //         newDivisions.some((div) => div.Division === sp.SalespersonCode.substring(0, 2))
        //     )
        //     onChange([...selectedValues, ...newSPData])
        // }
        setSelectedSalesDivisions(props.selectedSalesDivisions)
    }, [props.selectedSalesDivisions])

    const onChange = (value: Salesperson[]) => {
        setSelectedValues(value)
        props.onSelectedValuesChanged(value)
    }

    return (
        <DashboardMultiSelect
            data={salespeople}
            keyField="SalespersonCode"
            textField="SalespersonCodeName"
            selectedValues={selectedValues}
            onSelectedValuesChanged={onChange}
        />
    )
}

export default SalespersonMultiSelect
